import { usePatentDelete } from '@/module/Author/Patent';

import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

interface PatentDeleteButtonProps {
  patentId: Id;
}

export function PatentDeleteButton({ patentId }: PatentDeleteButtonProps) {
  const mutation = usePatentDelete(patentId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      size="xs"
      {...deleteProps}
    />
  );
}
